var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCosts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.5,
    height: 19.496,
    viewBox: "0 0 19.5 19.496",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_1302",
    "data-name": "Group 1302",
    transform: "translate(-840.149 -5214.464)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1707",
    "data-name": "Group 1707"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1711",
    "data-name": "Group 1711"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2046",
    "data-name": "Path 2046",
    d: "M858.9,5224.211a9,9,0,1,1-9-9A9,9,0,0,1,858.9,5224.211Z",
    transform: "translate(0 0)",
    fill: "#E4EAFF",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Component_5_1",
    "data-name": "Component 5 1",
    transform: "translate(840.551 5214.602)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_",
    "data-name": " ",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1710",
    "data-name": "Group 1710",
    style: {
      isolation: "isolate"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2185",
    "data-name": "Path 2185",
    d: "M10.079,9.074a12.727,12.727,0,0,1,1.488.546,2.507,2.507,0,0,1,.962.786,2.267,2.267,0,0,1,.4,1.4,2.416,2.416,0,0,1-.344,1.255,2.47,2.47,0,0,1-1.034.93,3.71,3.71,0,0,1-1.69.35H9.832v1.04H9.39V14.314A3.569,3.569,0,0,1,7.284,13.5a2.578,2.578,0,0,1-.91-1.8H7.96a1.62,1.62,0,0,0,.422.922,1.646,1.646,0,0,0,1.008.52V10.192a16.9,16.9,0,0,1-1.625-.565,2.571,2.571,0,0,1-.988-.774,2.214,2.214,0,0,1-.429-1.43,2.224,2.224,0,0,1,.383-1.287A2.54,2.54,0,0,1,7.8,5.265,3.807,3.807,0,0,1,9.39,4.953V3.848h.442V4.966a3.331,3.331,0,0,1,2.027.754A2.545,2.545,0,0,1,12.73,7.4h-1.6a1.506,1.506,0,0,0-.409-.812,1.6,1.6,0,0,0-.891-.449V9Zm-1.768-.8a3.3,3.3,0,0,0,1.079.579V6.1a1.646,1.646,0,0,0-1.066.344,1.155,1.155,0,0,0-.39.93A1.139,1.139,0,0,0,8.311,8.274Zm2.632,4.531a1.265,1.265,0,0,0,.4-.962,1.157,1.157,0,0,0-.39-.93,3.441,3.441,0,0,0-1.118-.578v2.847A1.543,1.543,0,0,0,10.943,12.805Z",
    fill: "#000000"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCosts);
export default __webpack_public_path__ + "static/media/Costs.894e2b5efcfccdd6625bee55ecdbaea4.svg";
export { ForwardRef as ReactComponent };